import { render, staticRenderFns } from "./ConfirmArea.vue?vue&type=template&id=5f4b0cce&scoped=true"
import script from "./ConfirmArea.vue?vue&type=script&lang=js"
export * from "./ConfirmArea.vue?vue&type=script&lang=js"
import style0 from "./ConfirmArea.vue?vue&type=style&index=0&id=5f4b0cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4b0cce",
  null
  
)

export default component.exports